// src/components/Header.jsx
import React from "react";

const Header = () => {
  return (
    <div
      style={{
        background: "white",
        padding: "30px",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        textAlign: "center",
        marginBottom: "30px",
      }}
    >
      <h1
        style={{
          color: "#2c3e50",
          fontSize: "2.2rem",
          marginBottom: "10px",
          fontWeight: "600",
        }}
      >
        🏥 Colon Cancer Detection System
      </h1>
      <p style={{ color: "#666", fontSize: "1.1rem" }}>
        AI-Powered Medical Image Analysis
      </p>
    </div>
  );
};

export default Header;
